export default function sleep(msTime) {
    return new Promise(function(resolve) {
        setTimeout(resolve, msTime || 0);
    });
}
